<template>
<div class="chapter">
<div class="inner_page">
<p class="ChapTitle"><a id="HLD3"></a>I<span class="small">NTRODUCTION</span></p>
<p class="txt">Putting together this collection of wool appliqué projects has been challenging and fun. The experience has stretched my creativity and has caused me to take a closer look not only at how I stitch and build a piece of art, but also at how I take it apart. This has allowed me to better understand my work and why I do things a certain way.</p>
<p class="txt">When the idea of writing this book began to take shape, I wanted to fill it with a variety of projects. I did not want to write a book of rules. On the contrary, I would like it to be a guide for the beginner and a new challenge for the seasoned stitcher.</p>
<p class="txt">In this book, you will find original and exciting wool appliqué patterns and the step-by-step instructions for completing them. As color is an important part of these projects, I have carefully chosen hues and shades that inspire those of us who love the nineteenth-century period and style. The hues have a beauty that I hope you can use and appreciate in your own home.</p>
<p class="txt">My true hope is that you enjoy the projects and find your own inspiration in these pages.</p>
<p class="fig"><img alt="" src="images/pg7_1.jpg"/></p>
<p class="fig"><img alt="" src="images/pg8_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_chapter03.vue?b135e2fc